import { Text } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/layout";
import { UnidadeHistoricoPessoaLog } from "core/features/unidades/typings/unidade";
import TimelineLogs from "components/TimelineLogs";

interface HistoricoProps {
  logs: UnidadeHistoricoPessoaLog[];
}

function Historico({ logs }: HistoricoProps) {
  return (
    <Flex flexDir="column">
      <Text fontSize={20} mb={1}>
        Histórico
      </Text>
      {logs.map((log, index) => (
        <TimelineLogs data={log} key={index} />
      ))}
    </Flex>
  );
}

export default Historico;
